<template>
  <div>
    <i class="fas fa-user"></i>
    <break-word-span
      :text="userRoute.userName"
      :maxLength="25"
    ></break-word-span>
    <br />
    <i class="fas fa-map-marker-alt color__blue"></i>
    <span class="font-size__small">Từ: </span>
    <break-word-span
      :text="userRoute.placeNameFrom"
      :maxLength="25"
    ></break-word-span>
    <br />
    <i class="fas fa-map-marker-alt color__red"></i>
    <span class="font-size__small">Đến: </span>
    <break-word-span
      :text="userRoute.placeNameTo"
      :maxLength="25"
    ></break-word-span>
  </div>
</template>

<script>
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import dateFormatter from "../../../filters/dateFormatter";
import BreakWordSpan from "../ketluan/break-word-span";
import constants from "../../../constants";
import HcMaybayUserRouteExtendInfoItem from "./hc-maybay-user-route-extend-info-item";

export default {
  name: "hc-maybay-user-route-hoten-changbay",
  mixins: [handleRequestErrorMixin],
  filters: { dateFormatter },
  components: { HcMaybayUserRouteExtendInfoItem, BreakWordSpan },
  props: ["userRoute"],

  data() {
    return {};
  },

  watch: {},

  created() {},

  methods: {
    getDateTimeLabel(value) {
      return dateFormatter(value, {
        dateFormat: constants.DEFAULT_DATETIME_FORMAT,
        nullValue: "-"
      });
    },

    getDateLabel(value) {
      return dateFormatter(value, {
        dateFormat: constants.DEFAULT_DATE_FORMAT,
        nullValue: "-"
      });
    },

    getGenderLabel(gender) {
      return hanhChinhUtils.getHcGenderLabel(gender);
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/vemaybay/hc-maybay-user-route-hoten-changbay.vue